import { Editor } from "../models/Editor";
import { serializer } from "./serializer";
function eventHTMLData(e: ClipboardEvent) {
	if (!e.clipboardData) {
		return;
	}

	if (e.clipboardData.types.includes("text/html")) {
		return e.clipboardData.getData("text/html");
	}
}
export class TextBuffer {
	private _editor: Editor;

	private _rawText: string;
	private _editorContent: any;

	constructor(editor) {
		this._editor = editor;
	}
	copy(event: ClipboardEvent) {
		event.preventDefault();
		const result = this._editor.copy();
		return this._setBuffer(event, result);
	}
	cut(event: ClipboardEvent) {
		event.preventDefault();
		const result = this._editor.cut();
		return this._setBuffer(event, result);
	}
	paste(event: ClipboardEvent) {
		event.preventDefault();
		let text;
		if (event.clipboardData) {
			text = event.clipboardData.getData("text/plain");
		} else {
			text = (window as any).clipboardData.getData("text");
		}
		if (text === this._rawText) {
			return this._editor.paste(this._editorContent, "inner");
		} else {
			const htmlData = eventHTMLData(event);
			if (htmlData) {
				return this._editor.paste(htmlData, "html");
			}
			return this._editor.paste(text, "text");
		}
	}

	private _setBuffer(event, result) {
		if (!result) {
			return false;
		}
		this._rawText = result.raw;
		this._editorContent = JSON.stringify(result.content);

		if (event.clipboardData) {
			event.clipboardData.setData("text/plain", result.raw);
			event.clipboardData.setData("text/html", serializer(result.content));
		} else {
			(window as any).clipboardData.setData("text", result.raw);
		}
		return true;
	}
}
